import template from 'lodash/template'

import { faBullhorn } from '@fortawesome/pro-light-svg-icons/faBullhorn'
import { faImages } from '@fortawesome/pro-light-svg-icons/faImages'
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'

import {
  AppFlagMapping,
  Application,
  AppMapping,
  HeaderIconMapping,
  HeaderMapping,
  HeaderTitle,
  URLBuilders
} from './common'

import { Application as AccountServiceApplication } from '@qc/account-service'

const SUITE_NAME = 'Q4M'

const SHOW_APPS_DROPDOWN = true
const SHOW_PRODUCT_DROPDOWN = true
const SHOW_NOTIFICATION_DROPDOWN = true
const SHOW_ACCOUNT_SWITCHER = true
const SHOW_ORG_SWITCHER = false
const SHOW_USER_INFO = false
const INCLUDE_BANNER_LINK = true

const HEADER_LIST = [HeaderTitle.ADS, HeaderTitle.AUDIENCES, HeaderTitle.ASSETS]

const HEADER_ICON_MAPPING: HeaderIconMapping = {
  [HeaderTitle.ADS]: faBullhorn,
  [HeaderTitle.AUDIENCES]: faUsers,
  [HeaderTitle.ASSETS]: faImages
}

const HEADER_MAPPING: HeaderMapping = {
  [HeaderTitle.ADS]: [Application.AdsManager, Application.Reports],
  [HeaderTitle.AUDIENCES]: [Application.Planner],
  [HeaderTitle.ASSETS]: [Application.CreativeLibrary, Application.Inventory, Application.QPixel]
}

const URL_MAPPING: AppMapping = {
  [Application.Planner]: '/ads/planner',
  [Application.AdsManager]: '/ads/manager',
  [Application.Reports]: '/ads/reports',
  [Application.CreativeLibrary]: '/ads/creatives',
  [Application.Inventory]: '/ads/inventory',
  [Application.QPixel]: '/ads/pixel'
}

const APP_NAME_MAPPING: AppMapping = {
  [Application.Planner]: 'Planner',
  [Application.AdsManager]: 'Campaigns',
  [Application.Reports]: 'Reports',
  [Application.CreativeLibrary]: 'Creatives',
  [Application.Inventory]: 'Inventory',
  [Application.QPixel]: 'Q Pixel'
}

const APP_DATA_SECTION_MAPPING: AppMapping = {
  [Application.Planner]: 'planner',
  [Application.AdsManager]: 'ads manager',
  [Application.Reports]: 'reports',
  [Application.CreativeLibrary]: 'creatives',
  [Application.Inventory]: 'inventory',
  [Application.QPixel]: 'qpixel'
}

const URL_BUILDERS: URLBuilders = {
  [Application.AdsManager]: template(`${URL_MAPPING[Application.AdsManager]}/accounts/\${id}/campaigns`),
  [Application.Planner]: template(`${URL_MAPPING[Application.Planner]}/\${pCode}/audience`),
  [Application.Reports]: template(`${URL_MAPPING[Application.Reports]}/\${id}`),
  [Application.CreativeLibrary]: template(`${URL_MAPPING[Application.CreativeLibrary]}/accounts/\${id}/creatives`),
  [Application.Inventory]: template(`${URL_MAPPING[Application.Inventory]}/accounts/\${id}/inventory`),
  [Application.QPixel]: template(`${URL_MAPPING[Application.QPixel]}/\${pCode}`)
}

const REQUIRED_APP_FLAGS: AppFlagMapping = {
  [Application.AdsManager]: AccountServiceApplication.Q_FOR_MARKETERS,
  [Application.Reports]: AccountServiceApplication.Q_FOR_MARKETERS,
  [Application.CreativeLibrary]: AccountServiceApplication.Q_FOR_MARKETERS,
  [Application.Inventory]: AccountServiceApplication.Q_FOR_MARKETERS,
}

export {
  APP_DATA_SECTION_MAPPING,
  APP_NAME_MAPPING,
  REQUIRED_APP_FLAGS,
  HEADER_ICON_MAPPING,
  HEADER_LIST,
  HEADER_MAPPING,
  INCLUDE_BANNER_LINK,
  SHOW_USER_INFO,
  SHOW_APPS_DROPDOWN,
  SHOW_ORG_SWITCHER,
  SHOW_ACCOUNT_SWITCHER,
  SHOW_PRODUCT_DROPDOWN,
  SHOW_NOTIFICATION_DROPDOWN,
  SUITE_NAME,
  URL_BUILDERS,
  URL_MAPPING
}
